<div class="modal-header d-flex justify-content-between align-items-center">
  <strong class="text-custom-theme bold fs-5">{{ prefix }}</strong>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>

<form #form="ngForm" class="form-validate">
  <div class="modal-body">
    <!-- ชื่อ-นามสกุล -->
    <div class="row g-3 mb-3">
      <div class="col-12 col-md-6">
        <label for="fname" class="form-label">ชื่อ / First Name</label>
        <input type="text" class="form-control" id="fname" name="fname" [(ngModel)]="userOfficialDto().fname" [disabled]="disable()" required
        #fname = 'ngModel'>
        @if (fname.invalid && (fname.touched || fname.dirty)) {
          <custom-error *ngIf="fname.hasError('required')" error="*จำเป็น"></custom-error>
        }
      </div>
      <div class="col-12 col-md-6">
        <label for="lname" class="form-label">นามสกุล / Last Name</label>
        <input type="text" class="form-control" id="lname" name="lname" [(ngModel)]="userOfficialDto().lname" [disabled]="disable()" required
        #lname='ngModel'>
        @if (lname.invalid && (lname.touched || lname.dirty)) {
          <custom-error *ngIf="lname.hasError('required')" error="*จำเป็น"></custom-error>
        }
      </div>
    </div>

    <!-- อีเมล-สิทธิ์ -->
    <div class="row g-3 mb-3">
      <div class="col-12 col-md-6">
        <label for="email" class="form-label ui-require">อีเมล / Email</label>
        <input
          #email="ngModel"
          type="email"
          [pattern]="emailPattern"
          [(ngModel)]="userOfficialDto().email"
          class="form-control"
          id="email"
          name="email"
          required
          [disabled]="disable()"
        >
        @if (email.invalid && (email.dirty || email.touched)) {
          <div class="ng-invalid-feedback">
            @if (email.errors?.['required']){
              <div>กรุณากรอกอีเมล</div>
            }
            @if (email.errors?.['pattern']){
              <div>อีเมลไม่ถูกต้อง</div>
            }
          </div>
        }
      </div>
      <div class="col-12 col-md-6">
        <label for="userType" class="form-label">สิทธิ์ / Role</label>
        <select class="form-select" id="userType" name="userType"
                [(ngModel)]="userOfficialDto().admin"
                [disabled]="userData()?.sub === userOfficialDto()?.ssoUserId">
          <option [ngValue]="true">ADMIN</option>
          <option [ngValue]="false">OFFICIAL</option>
        </select>
      </div>
    </div>

    <!-- เบอร์โทร-สถานะ -->
    <div class="row g-3 mb-3">
      <div class="col-12 col-md-6">
        <label for="enable" class="form-label">สถานะ / Status</label>
        <select class="form-select" id="enable" name="enable"
                [(ngModel)]="userOfficialDto().enable"
                [disabled]="userData()?.sub === userOfficialDto()?.ssoUserId">
          <option [ngValue]="true">เปิดใช้งาน (ACTIVE)</option>
          <option [ngValue]="false">ปิดใช้งาน (INACTIVE)</option>
        </select>
      </div>
    </div>
  </div>

  <!-- ปุ่มดำเนินการ -->
  <div class="modal-footer border-0 d-flex justify-content-center">
    <div class="d-flex gap-2 flex-wrap">
      <button type="button" class="btn btn-custom btn-custom-theme btn-main confirm-btn" (click)="save()">
        <i class="bi bi-send me-1"></i>
        บันทึก
      </button>
      <button type="button" class="btn btn-custom btn-light btn-main confirm-btn" (click)="activeModal.close()">
        <i class="bi bi-x-lg me-1"></i>
        ยกเลิก
      </button>
    </div>
  </div>
</form>
